import { CartItems } from "@app/components/CartItems";
import { EVENT_CART_UPDATE } from "@app/components/cart";
import { getProduct } from "@app/lib/product";
import { Cart } from "@app/types/cart";
import { Product } from "@app/types/product";
import React from "react";
import ReactDOM from "react-dom/client";

class MiniCart extends HTMLElement {
  $empty: HTMLDivElement | null = null;
  $shippingTracker: HTMLDivElement | null = null;
  $cartItems: HTMLDivElement | null = null;
  $orderSummary: HTMLDivElement | null = null;
  $orderSummaryButton: HTMLDivElement | null = null;


  constructor() {
    super();
    this.$empty = this.querySelector(".mini-cart-empty");
    this.$shippingTracker = this.querySelector(".mini-cart-free-shipping-tracker");
    this.$cartItems = this.querySelector(".mini-cart-items");
    this.$orderSummary = this.querySelector(".mini-cart-order-summary");
    this.$orderSummaryButton = this.querySelector(".toggle-order-summary-button");
  }

  connectedCallback() {
    document.addEventListener(EVENT_CART_UPDATE, async (e: any) => {
      if (e.detail?.cart) {
        const products = await this.fetchProducts(e.detail.cart);
        this.prepareMiniCart(e.detail.cart);
        this.renderItems(e.detail.cart, products);
      }
    });

    const $group = this.$orderSummaryButton?.closest(".group")!;
    const $badgeText = this.$orderSummaryButton?.querySelector(".badge-text")!;
    this.$orderSummaryButton?.addEventListener("click", () => {
      $group.classList.toggle("is-active");
      if ($group.classList.contains("is-active")) {
        $badgeText.textContent = "Hide order summary";
      } else {
        $badgeText.textContent = "Show order summary";
      }
    });
  }

  async fetchProducts(cart: Cart) {
    let handles = cart.items.map((item) => item.handle);
    handles = [...new Set(handles)];
    const products = await Promise.all(handles.map((handle) => getProduct(handle)));
    return products;
  }

  prepareMiniCart(cart: Cart) {
    if (cart.item_count > 0) {
      this.$empty?.classList.add("hidden");
      this.$shippingTracker?.classList.remove("hidden");
      this.$cartItems?.classList.remove("hidden");
      this.$orderSummary?.classList.remove("hidden");
    } else {
      this.$empty?.classList.remove("hidden");
      this.$shippingTracker?.classList.add("hidden");
      this.$cartItems?.classList.add("hidden");
      this.$orderSummary?.classList.add("hidden");
    }
  }

  renderItems(cart: Cart, products: Product[]) {
    if (this.$cartItems) {
      this.$cartItems.innerHTML = "";
    } else {
      return;
    }

    const root = ReactDOM.createRoot(this.$cartItems);
    root.render(<CartItems cart={cart} products={products} zCodeDisclaimer={this.dataset?.zCartDisclaimer} isMiniCart />);
  }
}

customElements.define("mini-cart", MiniCart);
